import React from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import "@/index.css";
import App from "@/App";
import axios from "axios";
import { Capacitor } from "@capacitor/core";

// Enable sending cookies with all axios requests
axios.defaults.withCredentials = true;

// Add interceptor to include session token from localStorage for iOS devices
axios.interceptors.request.use((config) => {
  const sessionToken = localStorage.getItem('session_token');
  if (sessionToken && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${sessionToken}`;
  }
  return config;
});

// Drop a stale backend session on 401 so callers can re-establish it from the
// still-valid Auth0 token. We deliberately do NOT redirect or force a logout
// here — that global side effect turned every transient 401 into a login loop.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('session_token');
      delete axios.defaults.headers.common['Authorization'];
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: Capacitor.isNativePlatform()
          ? "be.rmworx.cilantrosafe://callback"
          : window.location.origin + "/dashboard",
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: "openid profile email"
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
);
